import { useRouter } from "next/navigation";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import useMediaQuery from "@/hooks/use-media-query/use-media-query";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";
import { CoverLevelBenefits } from "@/schema/renewal-page/middle-panel.schema";
import { RootState } from "@/store/root-reducer";

import buildComparisonCards from "./build-comparison-cards";
import CoverLevelComparisonPanel from "./cover-level-comparison-panel";

type CoverLevelAllVariantProps = {
  cmsData: {
    coverLevelBenefits: CoverLevelBenefits;
    coverLevelTitle?: string;
    coverLevelComparisonSubtitle?: string;
    coverLevelComparisonEditLinkLabel?: string;
    coverLevelComparisonViewButtonLabel?: string;
    coverLevelComparisonSelectedButtonLabel?: string;
    coverLevelComparisonOrSeparator?: string;
    coverLevelComparisonMonthlySuffix?: string;
  };
};

function DashboardAllCoverLevels({
  cmsData,
}: Readonly<CoverLevelAllVariantProps>) {
  const router = useRouter();
  const { coverLevelBenefits } = cmsData;

  const { attributes } = useSelector((state: RootState) => state.quote);

  const isMobile = useMediaQuery("(max-width: 599px)");
  const { updateLastEditAccordion } = useRenewalStateContext();

  const navigateToCoverLevel = () => {
    updateLastEditAccordion("policy-details");
    router.push("/cover-level");
  };

  const cards = useMemo(
    () => buildComparisonCards(coverLevelBenefits, attributes),
    [coverLevelBenefits, attributes]
  );

  return (
    <div id="cover-level-main-section">
      <CoverLevelComparisonPanel
        cards={cards}
        selectedCoverType={attributes.tripDetails?.policyPackage}
        isMobile={isMobile}
        title={cmsData.coverLevelTitle}
        subtitle={cmsData.coverLevelComparisonSubtitle}
        editLinkLabel={cmsData.coverLevelComparisonEditLinkLabel}
        viewLabel={cmsData.coverLevelComparisonViewButtonLabel}
        selectedLabel={cmsData.coverLevelComparisonSelectedButtonLabel}
        orSeparator={cmsData.coverLevelComparisonOrSeparator}
        monthlySuffix={cmsData.coverLevelComparisonMonthlySuffix}
        onCardClick={navigateToCoverLevel}
        onEditDetailsClick={navigateToCoverLevel}
      />
    </div>
  );
}

export default DashboardAllCoverLevels;
